<script>
  import {Loading} from "carbon-components-svelte"

  export let iconLeft = false;
  export let iconRight = false;
  export let showText = true;
  export let color = "orange";
  export let enlarge = false;
  export let external = false;
  export let download = false;
  export let setting = false;
  export let secondary = false;
  export let danger = false;
  export let disabled = false;
  export let iconOnly = false;
  export let loading = false;

  export let text = "change text";
  export let icon = "arrow_right";

  let linkTarget = "";

  $: linkTarget = external ? "_blank" : "";

  export let url = "/";
</script>

{#if setting === true}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    tabindex="0"
    class={`mainbutton ${color === "white" ? "white_button" : ""} ${
      enlarge === true ? "enlarge" : ""
    } ${secondary === true ? "secondary" : ""} ${danger === true ? "danger" : ""} ${disabled ? "disabled" : ""}`}
    class:icon_only={iconOnly === true}
    role="button"
    aria-label={text}
    aria-haspopup={external ? "true" : "false"}
    on:click
  > 
    {#if loading===true}
    <Loading small withOverlay={false} active={loading}></Loading>

    {:else}{#if iconLeft === true}
      <div class="icon">
        <img src="/img/assistant/icons/{icon}.svg" alt={icon} />
      </div>
    {/if}
    {#if showText === true}
      <div class="button_text">{text}</div>
      
    {/if}
    {#if iconRight === true}
      <div class="icon">
        <img src="/img/assistant/icons/{icon}.svg" alt={icon} />
      </div>
    {/if}
    {/if}
  </div>
{:else}
  <a
    tabindex="0"
    href={url}
    target={linkTarget}
    rel={external ? "noopener noreferrer" : ""}
    {...download === true ? { download: "" } : {}}
    class={`mainbutton ${color === "white" ? "white_button" : ""} ${
      enlarge === true ? "enlarge" : ""
    } ${secondary === true ? "secondary" : ""} ${danger === true ? "danger" : ""} ${disabled ? "disabled" : ""}`}
    role="button"
    aria-label={text}
    aria-haspopup={external ? "true" : "false"}
    >

    {#if iconOnly === true}
      <div class="icon_only">
        <img src="/img/assistant/icons/{icon}.svg" alt={icon} />
      </div>
    {:else}{#if iconLeft === true}
        <div class="icon">
          <img src="/img/assistant/icons/{icon}.svg" alt={icon} />
        </div>
      {/if}
      {#if showText === true}
        <div class="button_text">{text}</div>
      {/if}
      {#if iconRight === true}
        <div class="icon">
          <img src="/img/assistant/icons/{icon}.svg" alt={icon} />
        </div>
      {/if}
    {/if}
   
     
  </a>
{/if}

<style>
  .mainbutton {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 3rem !important;
    gap: 1rem;
    padding: 0.8rem 1.2rem;
    border-radius: 0.5rem;
    background-color: #ff5f1f;
    width: fit-content;
    color: white;
    transition: 300ms ease-in-out !important;
    cursor: pointer;
    user-select: none;
  }

  .mainbutton:hover {
    background-color: #2a2a2f;
  }

  .white_button {
    background-color: white;
    color: var(--pax-black);
  }

  .white_button:hover {
    background-color: #ffffff80;
  }

  .secondary {
    background-color: var(--pax-black);
    user-select: none;
    color: white;
  }

  .secondary:hover {
    background-color: #1c1c2080;
    color: white;
  }

  .danger {
    background-color: var(--pax-danger);
    color: white;
  }

  .danger:hover {
    background-color: #ff000080;
    color: white;
  }

  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .icon img {
    fill: white;
    color: white;
    height: 1.2rem;
    width: 1rem;
  }

  .enlarge {
    width: 100%;
  }

  .disabled {
    cursor: not-allowed;
    opacity: 30%;
  }
</style>
